<template>
  <div id="author-suggest-oppose-reviewers">
    <!-- Suggested Reviewer -->
    <div class="mar-b-60">
      <div class="ipub-p2 mar-b-20">
        <!-- <ipub-button type="primary"
                     :style="{ minWidth: '200px' }"
                     @click="skip">Skip this Step</ipub-button> -->
        You can recommend or avoid potential reviewers for this manuscript. If not, you can <a class="link-color"
           @click="skip">skip this step</a>.
      </div>
      <div class="ipub-h2 mar-b-10 line-h-40 relative">
        Suggested Reviewer(s)
      </div>
      <template v-for="(item, index) in params.suList">
        <div :key="item.id"
             class="reviewer-content mar-b-10">
          <div class="ipub-p2 fw-bd mar-b-16 relative">
            # Suggest Reviewer {{index+1}}
            <div class="right-option"
                 v-if="params.suList.length>1">
              <a @click="del('suList', index)"
                 class="ipub-p2">
                <ipub-icon type="iconDelete" />
              </a>
            </div>
          </div>
          <ipub-form :ref="'author-edit-form'+index"
                     :model="item"
                     :rules="rules">
            <ipub-row :gutter="12">
              <ipub-col :span="4">
                <ipub-form-item prop="email"
                                label="Email">
                  <ipub-input placeholder="Email"
                              v-model.trim="item.email" />
                </ipub-form-item>
              </ipub-col>
              <ipub-col :span="4">
                <ipub-form-item prop="firstName"
                                label="First Name">
                  <ipub-input placeholder="First Name"
                              v-model.trim="item.firstName" />
                </ipub-form-item>
              </ipub-col>
              <ipub-col :span="4">
                <ipub-form-item prop="lastName"
                                label="Last Name">
                  <ipub-input placeholder="Last Name"
                              v-model.trim="item.lastName" />
                </ipub-form-item>
              </ipub-col>
            </ipub-row>
            <ipub-form-item prop="affiliation"
                            label="Affiliation">
              <ipub-textarea placeholder="Affiliation"
                             v-model.trim="item.affiliation" />
            </ipub-form-item>
          </ipub-form>
        </div>
      </template>
    </div>
    <div class="add-author-button">
      <div class="add-author-button-line"></div>
      <ipub-button type="primary"
                   style="width:300px;margin:0 10px"
                   @click="addMore('suList')"
                   icon="iconAdd">
        Add New Suggested Reviewer
      </ipub-button>
      <div class="add-author-button-line"></div>
    </div>
    <!-- Oppose Reviewer -->
    <div class="mar-b-40">
      <div class="ipub-h2 mar-b-10 line-h-40 relative">
        Opposed Reviewer(s)
      </div>
      <template v-for="(item, index) in params.opList">
        <div :key="item.id"
             class="reviewer-content mar-b-10">
          <div class="ipub-p2 fw-bd mar-b-16 relative">
            # Opposed Reviewer {{index+1}}
            <div class="right-option"
                 v-if="params.opList.length>1">
              <a @click="del('opList', index)"
                 class="ipub-p2">
                <ipub-icon type="iconDelete" />
              </a>
            </div>
          </div>
          <ipub-form :ref="'author-edit-form'+index"
                     :model="item"
                     :rules="rules">
            <ipub-row :gutter="12">
              <ipub-col :span="4">
                <ipub-form-item prop="email"
                                label="Email">
                  <ipub-input placeholder="Email"
                              v-model.trim="item.email" />
                </ipub-form-item>
              </ipub-col>
              <ipub-col :span="4">
                <ipub-form-item prop="firstName"
                                label="First Name">
                  <ipub-input placeholder="First Name"
                              v-model.trim="item.firstName" />
                </ipub-form-item>
              </ipub-col>
              <ipub-col :span="4">
                <ipub-form-item prop="lastName"
                                label="Last Name">
                  <ipub-input placeholder="Last Name"
                              v-model.trim="item.lastName" />
                </ipub-form-item>
              </ipub-col>
            </ipub-row>
            <ipub-form-item prop="affiliation"
                            label="Affiliation">
              <ipub-textarea placeholder="Affiliation"
                             v-model.trim="item.affiliation" />
            </ipub-form-item>
          </ipub-form>
        </div>
      </template>
    </div>
    <div class="add-author-button">
      <div class="add-author-button-line"></div>
      <ipub-button type="primary"
                   style="width:300px;margin:0 10px"
                   @click="addMore('opList')"
                   icon="iconAdd">
        Add New Opposed Reviewer
      </ipub-button>
      <div class="add-author-button-line"></div>
    </div>
    <div slot="footer">
      <ipub-button plain
                   style="width:150px"
                   @click="() => { $router.back(-1)}"
                   type="primary">Previous</ipub-button>
      <ipub-button type="primary"
                   plain
                   :style="{ minWidth: '150px' }"
                   @click="skip">Skip this Step</ipub-button>
      <ipub-button type="primary"
                   :style="{ minWidth: '150px' }"
                   @click="submit">Save & Next</ipub-button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
